'use strict';

var _ = require('lodash');

var getViewportWidth = function getViewportWidth() {
  return _.max([document.documentElement.clientWidth, window.innerWidth, 0]);
};

module.exports = getViewportWidth;